export default __webpack_public_path__ + "static/media/CEX.b1669ef3.png";